import firebaseService from '../../firebase'
import {
  ref as firebaseRef,
  uploadString,
  uploadBytes,
  getDownloadURL
} from 'firebase/storage'
import { ref } from 'vue'

const useStorage = () => {
  const uploadError = ref('')
  const url = ref('')
  const uploadImagePending = ref(false)
  const doctor = firebaseService.firebaseAuth.currentUser

  const uploadImage = async (dataUrl, filePath) => {
    uploadImagePending.value = true
    let storageRef
    if (filePath) {
      storageRef = firebaseRef(firebaseService.storage, filePath)
    } else {
      storageRef = firebaseRef(firebaseService.storage, `doctorAvatars/${doctor.uid}`)
    }

    try {
      await uploadString(storageRef, dataUrl, 'data_url')
      url.value = await getDownloadURL(storageRef)
      uploadImagePending.value = false
      return url.value
    } catch (err) {
      uploadError.value = err
    }
  }

  const uploadImageFile = async (file, filePath) => {
    uploadImagePending.value = true
    let storageRef
    if (filePath) {
      storageRef = firebaseRef(firebaseService.storage, filePath)
    } else {
      storageRef = firebaseRef(firebaseService.storage, `doctorAvatars/${doctor.uid}`)
    }

    try {
      await uploadBytes(storageRef, file)
      url.value = await getDownloadURL(storageRef)
      uploadImagePending.value = false
      return url.value
    } catch (err) {
      uploadError.value = err
    }
  }

  return { uploadError, url, uploadImage, uploadImagePending, uploadImageFile }
}

export default useStorage
